module.exports = __webpack_public_path__ + "img/school_ex_1.6d45f72c.png";